import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "plus-circle",
  "use": "plus-circle-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 17\" id=\"plus-circle\"><path d=\"M14.423 8.5a5.924 5.924 0 1 0-11.848.002A5.924 5.924 0 0 0 14.423 8.5m2 0a7.923 7.923 0 1 1-15.847 0 7.923 7.923 0 0 1 15.847 0\" /><path d=\"M5.353 9.5h6.294a1 1 0 1 0 0-2H5.353a1 1 0 0 0 0 2\" /><path d=\"M9.5 11.647V5.354a1 1 0 1 0-2 0v6.293a1 1 0 0 0 2 0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol